export default __webpack_public_path__ + "static/media/banner@2x.17947078.jpg";